// NoResult.js
import React from 'react';
import { NamedLink } from '../../../../components';
import { FormattedMessage } from '../../../../util/reactIntl';
import css from './NoResult.module.css';

const categories = [
  { name: 'Camping Gear', items: 'Tents, sleeping bags, backpacks, and more.' },
  {
    name: 'Sports Equipment',
    items: 'Bicycles, surfboards, kayaks, and fitness gear.',
  },
  {
    name: 'Photography Equipment',
    items: 'Cameras, lenses, tripods, and accessories.',
  },
  {
    name: 'Party Supplies',
    items: 'Tables, chairs, decorations, and audio equipment.',
  },
  {
    name: 'Tools and Equipment',
    items: 'Power tools, gardening tools, and construction equipment.',
  },
];

const benefits = [
  {
    title: 'Earn Extra Income',
    description: 'Make money from items you already own.',
  },
  {
    title: 'Reach a Wider Audience',
    description: 'Connect with renters in your area.',
  },
  {
    title: 'Flexible Listings',
    description: 'Choose your rental terms and availability.',
  },
];

const PromotionContent = ({ intl, storeUserName }) => {
  return (
    <div className={css.emptyStoreMessage}>
     <h4><FormattedMessage id="PromotionalContent.greet" values={{name:storeUserName}}/></h4>
      <h2>
        <FormattedMessage id="PromotionalContent.mainHeading" />
      </h2>
      <p>
        <FormattedMessage id="PromotionalContent.subHeading" />
      </p>
      <ul>
        {categories.map((category, index) => (
          <li key={`category-${index}`}>
            <strong>{category.name}:</strong> {category.items}
          </li>
        ))}
      </ul>
      <h3>
        <FormattedMessage id="PromotionalContent.awarenessMessageTitle" />
      </h3>
      <ul>
        {benefits.map((benefit, index) => (
          <li key={`benefit-${index}`}>
            <strong>{benefit.title}:</strong> {benefit.description}
          </li>
        ))}
      </ul>
      <p>
        <FormattedMessage id="PromotionalContent.readyToStartMessage" />
        <strong>
          <FormattedMessage id="PromotionalContent.addFirstItemMessage" />
        </strong>
        <FormattedMessage id="PromotionalContent.watchRentalMessage" />
      </p>
      <NamedLink className={css.addItemButton} name="NewListingPage">
        <FormattedMessage id="PromotionalContent.createListingButtonText" />
      </NamedLink>
    </div>
  );
};

const NoResult = ({ isCurrentUser, intl, storeUserName }) => {
  return (
    <div className={css.emptyStateContainer}>
      {isCurrentUser ? (
        <PromotionContent intl={intl} storeUserName={storeUserName}/>
      ) : (
        <p className={css.emptyStateMessage}>
          <FormattedMessage id="StoreProfilePage.noResults" />
        </p>
      )}
    </div>
  );
};

export default NoResult;
